const documentTypes = [
  'FS240',
  'DS1350',
  'CitizenshipCertificate',
  'Passport',
  'AlienRegistrationSF85P',
  'CertificateOfNaturalization',
  'None',
  'Other',
];

export default documentTypes;
